import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton";
import TitleRecordFunction from "../../components/TitleRecordFunction";
import api from '../../api/manage_database/FlowMeterReq';
import { toast } from 'sonner';

const FlowMeterRecord = () => {
    
    const navigate = useNavigate();
    const locationApp = useLocation();

    const addRecordMessage = locationApp.state?.addRecordMessage;
    const deleteRecordMessage = locationApp.state?.deleteRecordMessage;
    
    const isViewRecord = locationApp.state?.anotherTypeOfPage === undefined;

    const { flow_meter_id } = useParams();

    const deletedFlowMeter = locationApp.state?.data

    const [flowMeterData, setFlowMeterData] = useState({
        'id': '',
        'name': '',
        'converter': {
            'id': '',
            'track_amount': '',
            'type': '',
        },
        'sensor': {
            'id': '',
            'dimension': '',
            'serial_number': '',
            'type': ''
        },
        'location': {
            'id': '',
            'place': '',
            'thoroughfare': '',
            'type_line': ''
        },
    });

    
    const [isClickedInfoFrameButton, setIsClickedInfoFrameButton] = useState(false);
    const [infoFrame, setInfoFrame] = useState({});
    
    const handleInfoFrameButton = () => {
         const fetchInfoFrameData = async () => {
            try {
                const response = await api.get(`info-frame/${flow_meter_id}`, {withCredentials: true});
                if (response.data.success) {
                    setInfoFrame(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
                
            } catch (err) {
                console.log(err.response);
            }
        };

        fetchInfoFrameData();
        setIsClickedInfoFrameButton(true)
    };

    const hideInfoFrame = () => setIsClickedInfoFrameButton(false);

    const handleEditButton = (v) => {
        if (v === 1) {
            navigate(`../../location/record/${flowMeterData.location.id}`)
        } else if (v === 2) {
            navigate(`../../sensor/record/${flowMeterData.sensor.id}`)
        } else if (v === 3) {
            navigate(`../../converter/record/${flowMeterData.converter.id}`)
        }
    }

        
        
    

    useEffect(() => {
        const getFlowMeterDescriptionData = async() => {
            let attempts = 0;
            while (attempts < 5) {
                try {
                    const response = await api.get(`record/${flow_meter_id}`, {withCredentials: true})
                    if (response.data.success) {
                        setFlowMeterData(response.data.payload);
                        return
                    } else {
                        toast.warning('Not got data from database! trying again...');
                    }
                    
                } catch (err) {
                    console.log(err.response);
                }
                
                attempts++;
                if (attempts < 5) {
                    await new Promise((res) => setTimeout(res, 2000));
                }
            }

            toast.error(`Data is not received after ${attempts} requests!`);
            
        };
        if (deletedFlowMeter === undefined) {
            getFlowMeterDescriptionData();
        } else {
            setFlowMeterData(deletedFlowMeter);
        }
    }, []);
    
    return (
        <div className='flow-meter-record-container'>
            <TitleRecordFunction
                addRecordMessage={addRecordMessage}
                deleteRecordMessage={deleteRecordMessage}
                title='Flow Meter'
                isViewRecord={isViewRecord}
            />            
            <table className='flow-meter-record-table-style'>
                <tbody>
                    <tr>
                        <td>Flow Meter:</td>
                        <td>{flow_meter_id}</td>
                    </tr>
                    <tr>
                        <td>Location:</td>
                        <td className="flow-meter-record-edit-button-position">
                            {flowMeterData.location.place !== '' && flowMeterData.location.place}<br />
                            {flowMeterData.location.thoroughfare !== '' && flowMeterData.location.thoroughfare}<br />
                            {flowMeterData.location.type_line !== '' && flowMeterData.location.type_line}
                            {deletedFlowMeter === undefined && <button
                                    className='flow-meter-record-edit-button'
                                    onClick={() => handleEditButton(1)}
                            >   Edit
                            </button>}
                        </td>
                    </tr>
                    <tr>
                        <td>Sensor:</td>
                        <td className="flow-meter-record-edit-button-position">
                            {flowMeterData.sensor.type !== '' && flowMeterData.sensor.type}<br />
                            {flowMeterData.sensor.dimension !== '' && flowMeterData.sensor.dimension}<br />
                            {flowMeterData.sensor.serial_number !== '' && flowMeterData.sensor.serial_number}
                            {deletedFlowMeter === undefined && <button
                                    className='flow-meter-record-edit-button'
                                    onClick={() => handleEditButton(2)}
                            >   Edit
                            </button>}
                        </td>
                    </tr>
                    <tr>
                        <td>Converter:</td>
                        <td className="flow-meter-record-edit-button-position">
                            {flowMeterData.converter.type !== '' && flowMeterData.converter.type}<br />
                            {flowMeterData.converter.track_amount !== '' && flowMeterData.converter.track_amount}<br />
                            {deletedFlowMeter === undefined && <button
                                    className='flow-meter-record-edit-button'
                                    onClick={() => handleEditButton(3)}
                            >   Edit
                            </button>}
                        </td>
                    </tr>
                </tbody>       
            </table>
            {isViewRecord && <button className='flow-meter-record-button' onClick={() => navigate(`../manage-uploaded-data/${flow_meter_id}`)}>
                        Manage uploaded data
                </button>}
            {isViewRecord && 
                !isClickedInfoFrameButton? 
                    <button className="flow-meter-record-button" onClick={handleInfoFrameButton}>Show Info Frame</button>
                    : <div className="table-wrapper-info-frame">
                        <table
                            className="flow-meter-record-table-info-frame-style"
                        >
                            {Object.entries(infoFrame).map(([key, value]) => {
                                return <tr key={key}>
                                    <td style={{height: '2rem'}}>{key}</td>
                                    <td style={{height: '2rem'}}>{value}</td>
                                </tr>
                            })}
                        </table>
                    </div>                        
            }
            {isClickedInfoFrameButton? <button className="flow-meter-record-button" onClick={hideInfoFrame}>Hide Info Frame</button>: null}
            <BackButton
                navigateTo='/manage-database'
            />
        </div>
    )
}

export default FlowMeterRecord;